module.exports = __webpack_public_path__ + "media/fonts/copyfonts.com_gotham_bold_0-46e967b8.ttf";